import { DateField, TextField } from 'react-admin';

import { EventLogEntry } from 'types/LiveLogs';
import { LiveLogDatagrid } from './LiveLogDatagrid';
import { HIDE_BELOW_SM, liveLogColumnLabel, LOG_DATE_TIME_FORMAT } from './liveLogs';
import { monoSx, tabularSx, twoLineMonoSx } from './logCellSx';

export const EventLogGrid = () => (
  <LiveLogDatagrid>
    <DateField<EventLogEntry>
      source="timestamp"
      emptyText="-"
      label={liveLogColumnLabel('time')}
      sortable={false}
      showTime
      options={LOG_DATE_TIME_FORMAT}
      sx={tabularSx}
    />
    <TextField<EventLogEntry>
      source="event"
      label={liveLogColumnLabel('event')}
      sortable={false}
      emptyText="-"
      sx={monoSx}
    />
    <TextField<EventLogEntry>
      source="message"
      label={liveLogColumnLabel('message')}
      sortable={false}
      emptyText="-"
      sx={twoLineMonoSx}
    />
    <TextField<EventLogEntry>
      source="software_version"
      label={liveLogColumnLabel('version')}
      sortable={false}
      emptyText="-"
      sx={monoSx}
      cellClassName={HIDE_BELOW_SM}
      headerClassName={HIDE_BELOW_SM}
    />
  </LiveLogDatagrid>
);
